<template>
    <div class="colors">
        <div
            v-if="hasColors"
            class="settings-field"
        >
            <p class="title">
                Player color:
            </p>
            <div class="options">
                <div class="row-container">
                    <base-color-picker
                        :color="settings.color"
                        @change="value => $emit('change', { color: value })"
                    />
                </div>
            </div>
        </div>
        <base-settings-row
            v-else
            input-type="radio"
            config-title="Player color"
            :fields-config="freePlayerColorsConfig"
            :binded-value="settings.color"
            settings-key="color"
            class="is-centered without-border"
            :input-class="['is-round']"
            @change="value => $emit('change', { ...value })"
        />
        <base-settings-row
            v-if="hasColors && 'archive' === playerType"
            class="is-centered"
            config-title="Playlist"
            input-type="radio"
            :fields-config="playerColorModeConfig"
            :binded-value="settings.playlist.color"
            settings-key="color"
            :input-class="['is-round']"
            @change="value => $emit('nested-config-change', { parent: 'playlist', data: { ...value } })"
        />
    </div>
</template>

<script>
import playerSettings from '@/utils/config/playerSettings';
import { Feature, hasFeature } from '@/utils/show';

const { freePlayerColorsConfig } = playerSettings;

export default {
    props: {
        settings: {
            type: Object,
            required: true,
        },

        show: {
            type: Object,
            required: true,
        },

        playerType: {
            type: String,
            default: 'archive',
        },
    },

    data: () => ({
        playerColorModeConfig: [
            {
                label: 'Light mode',
                value: 'light',
            },
            {
                label: 'Dark mode',
                value: 'dark',
            },
            {
                label: 'Auto-detection',
                value: 'auto',
            },
        ],
        freePlayerColorsConfig,
    }),

    computed: {
        /**
         * Checks if the show has color customization feature enabled.
         *
         * @returns {boolean} True if the show has color customization feature.
         */
        hasColors() {
            return hasFeature(this.show, Feature.ColorCustomization);
        },
    },
};
</script>
